
import Vue from 'vue';
import { mapState } from 'vuex';

import LoadingStore from './store';

const Loading =  {
    name: 'Loading',
    data() {
		return {};
	},
    computed: mapState({
        show: (state) => state.Loading.show,
        mask: (state) => state.Loading.mask,
    }),
    created() {
        if (!this.$store.state.Loading) {
            this.$store.registerModule('Loading', LoadingStore);
        }
    },
    methods: {

    }
};

export default Loading;



// WEBPACK FOOTER //
// ./src/ui/loading/index.js